export const vkLink = 'https://vk.com/kpmstav';
export const tgLink = 'https://t.me/stavrossmed';